import { Link as RouterLink } from 'react-router-dom'
import { Box, Link, Paper, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { MOCK_ASSIGNED_REP, MOCK_CLIENT_NAME } from '../../data/mockSeed'
import { markClientOnboardingComplete } from '../../lib/onboardingPortalFlags'
import { AppRoutes } from '../../../helper/appRoutes'
import { MISC_PRIMARY, MISC_PRIMARY_HOVER } from '../../theme/onboardingTheme'

export function StepComplete() {
  const { state } = useOnboarding()
  const st = state.serviceType ?? '—'

  return (
    <Stack spacing={3} sx={{ textAlign: 'center' }}>
      <Box
        sx={{
          alignSelf: 'center',
          display: 'flex',
          height: 64,
          width: 64,
          flexShrink: 0,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          backgroundColor: '#d1fae5',
          fontSize: '1.875rem',
        }}
      >
        ✓
      </Box>
      <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, color: '#0f172a' }}>
        Onboarding complete
      </Typography>
      <Typography sx={{ fontSize: 14, color: '#475569' }}>
        All wizard steps for this demo are satisfied. In production, MISC would verify flagged
        items before activation.
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          borderColor: '#e2e8f0',
          borderRadius: '12px',
          backgroundColor: '#ffffff',
          p: 3,
          textAlign: 'left',
          boxShadow: 1,
        }}
      >
        <Box
          component="dl"
          sx={{
            display: 'grid',
            m: 0,
            gap: 1.5,
            fontSize: 14,
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          }}
        >
          <Box>
            <Typography
              component="dt"
              sx={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', color: '#64748b' }}
            >
              Client
            </Typography>
            <Typography component="dd" sx={{ m: 0, fontWeight: 500, color: '#0f172a' }}>
              {MOCK_CLIENT_NAME}
            </Typography>
          </Box>
          <Box>
            <Typography
              component="dt"
              sx={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', color: '#64748b' }}
            >
              Services
            </Typography>
            <Typography component="dd" sx={{ m: 0, fontWeight: 500, color: '#0f172a' }}>
              {st}
            </Typography>
          </Box>
          <Box>
            <Typography
              component="dt"
              sx={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', color: '#64748b' }}
            >
              Transition date
            </Typography>
            <Typography component="dd" sx={{ m: 0, fontWeight: 500, color: '#0f172a' }}>
              {state.otrTransitionDate || 'Not set (non-tax)'}
            </Typography>
          </Box>
          <Box>
            <Typography
              component="dt"
              sx={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', color: '#64748b' }}
            >
              MISC contact
            </Typography>
            <Typography component="dd" sx={{ m: 0, fontWeight: 500, color: '#0f172a' }}>
              {MOCK_ASSIGNED_REP}
            </Typography>
          </Box>
        </Box>
      </Paper>
      <Link
        component={RouterLink}
        to={AppRoutes.client.home}
        onClick={() => markClientOnboardingComplete()}
        underline="none"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          alignSelf: 'center',
          borderRadius: '8px',
          backgroundColor: MISC_PRIMARY,
          px: 4,
          py: 1.5,
          fontSize: 14,
          fontWeight: 600,
          color: '#ffffff',
          boxShadow: 1,
          '&:hover': { backgroundColor: MISC_PRIMARY_HOVER, color: '#ffffff' },
        }}
      >
        Go to portal
      </Link>
    </Stack>
  )
}
